// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"82":"12496696","840":"3309376b"}[chunkId] + ".js";
};